import {
    UPLOAD_BANNER_IMAGE_FAILED,
    UPLOAD_BANNER_IMAGE_SUCCESS,
    UPLOAD_BANNER_IMAGE_REQUEST
} from "../Actions/HtmlBannerActions";

const InitialState = {
    loading: false, 
    success: false
};

export const HtmlbannerReducer = (state = InitialState, action: any) => {
    switch (action.type) {
        case UPLOAD_BANNER_IMAGE_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case UPLOAD_BANNER_IMAGE_SUCCESS:
            return {
                ...state,
                loading: false,
            };

        case UPLOAD_BANNER_IMAGE_FAILED:
            return {
                ...state,
                loading: false,
            }; 
        default:
            return state;
    }
}